import type { TOC } from '@ember/component/template-only';

import MetricsPageComponent from 'webapp/components/metrics/page';

// The Company metrics page stays mounted while its child routes open popups (edit, clean-up, details) over it.
const MetricsRouteTemplate: TOC<object> = <template>
	<MetricsPageComponent />
	{{outlet}}
</template>;

export default MetricsRouteTemplate;
